<template>
  <div id="activeCollection-card" class="card" v-if="activeCollection">
    <div id="top-row">
      <h2>
        {{ activeCollection.name }}
      </h2>
      {{ activeCollection.emoji }}
    </div>
    <p>
      {{ activeCollection.description }}
    </p>
  </div>
  <button class="button">Start Learning</button>
</template>

<script>
import { supabase } from "../supabase";

export default {
  name: "CollectionPreview",
  data() {
    return {
      activeCollection: {},
    };
  },
  mounted: async function () {
    try {
      const { error, data } = await supabase
        .from("packs")
        .select()
        .eq("id", this.$route.params.id);
      if (error) throw error;
      
      this.activeCollection = data[0];
    } catch (error) {
      console.warn(error.error_description || error.message);
      Toastify({
        text:
          "Something went wrong. Try again or reload the page. \n Error 1: \n" +
            error.error_description ||
          error.message ||
          error,
        duration: 3000,
        newWindow: true,
        close: true,
        gravity: "top", // `top` or `bottom`
        position: "center", // `left`, `center` or `right`
        stopOnFocus: true, // Prevents dismissing of toast on hover
        style: {
          background: "var(--primary-500)",
        },
      }).showToast();
    }
  },
};
</script>